import { apiUrl } from "@/lib/api-base";
import { notifyApiError } from "@/lib/api-error";
import { getAuthToken } from "@/lib/auth";

export type ApiFetchInit = RequestInit & {
  auth?: boolean;
};

export async function apiFetch(path: string, init?: ApiFetchInit) {
  const { auth = true, ...requestInit } = init ?? {};
  const token = auth ? getAuthToken() : "";

  const response = await fetch(apiUrl(path), {
    ...requestInit,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...requestInit.headers
    }
  });

  if (!response.ok) {
    await notifyApiError(response);
  }

  return response;
}
